export const CREDIT_ROUTING = [
    {
        path: '/vi-tien.html',
        name: 'credit',
        redirect: { name: 'profile', query: { tab: 'finance' } },
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Nạp - rút tiền', icon: 'fa fa-money' },
        ] },
        children: [], 
    }
];